import React, { useMemo } from "react";
import { isString } from "@common/helpers/typeGuards";
import { TransactionRuleCondition } from "@common/types/transactionRule";
import { useCategoryLabelGetter } from "@hooks/useCategoryLabelGetter";
import { RuleTagRow } from "../RuleTagRow";

interface Props {
    condition: TransactionRuleCondition;
}

export const RuleCategoryCondition: React.FC<Props> = ({ condition }) => {
    const categoryLabelGetter = useCategoryLabelGetter();

    const categoryLabel = useMemo(() => {
        if (isString(condition.value)) {
            return categoryLabelGetter(condition.value);
        }
    }, [categoryLabelGetter, condition.value]);

    if (categoryLabel) {
        return (
            <RuleTagRow
                label="Category"
                type="condition"
                values={[categoryLabel]}
            />
        );
    }

    if (Array.isArray(condition.value)) {
        const labels = condition.value
            .map((id) => categoryLabelGetter(id as string))
            .filter((label): label is string => !!label);

        if (!labels.length) {
            return null;
        }

        return <RuleTagRow label="Category" type="condition" values={labels} />;
    }

    return null;
};
